/* eslint-disable no-unused-expressions */
import React from "react";
import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { MaskedTextBox } from "@progress/kendo-react-inputs";
import "./MaskedTextBox.scss";

/**
 * Numeric text box component
 * @module
 * @param {string} name - Name
 * @param {func} onChange - Function invoked on value change
 * @param {func} [onBlur] - Function invoked on input blur
 * @param {string} [value] - Current value
 * @param {bool} [required] - Is input required?
 * @param {string} [validationMessage] - Validation message if field is invalid
 * @param {bool} [disabled] - Is input readonly?
 * @param {number} [tabIndex] - Tabindex
 * @param {string} [placeholder] - Placeholder
 * @param {string} [mask] - Mask
 * @param {string} [defaultValue] - Default value
 * @param {string} [title] - Title - shows on focus above cursor
 */
const MaskedTextBoxComponent = ({
  name,
  value,
  required,
  validationMessage,
  disabled,
  tabIndex,
  placeholder,
  className,
  onChange,
  mask,
  defaultValue,
  title,
  onBlur,
}) => {
  const classNameHandled =
    'maskedtextbox ' +
    (disabled ? 'disabled-field' : '') +
    (className ? className : '');

  const handleBlur = () => {
    if (onBlur) {
      onBlur(name, value);
    }
  };

  const maskedTextBoxRef = useRef(null);
  useEffect(() => {
    if (maskedTextBoxRef.current && maskedTextBoxRef.current.element && name) {
      maskedTextBoxRef.current.element.setAttribute('data-testid', name);
    }
  }, [name])

  return (
    <div className={classNameHandled}>
      <MaskedTextBox
        onChange={(e) => onChange(name, e.target.value)}
        onBlur={handleBlur}
        value={value}
        required={required}
        validationMessage={validationMessage || 'Povinné'}
        disabled={disabled}
        tabIndex={tabIndex}
        placeholder={placeholder}
        mask={mask}
        defaultValue={defaultValue}
        title={title}
        ref={maskedTextBoxRef}
      />
    </div>
  );
};

MaskedTextBoxComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool,
  validationMessage: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  placeholder: PropTypes.string,
  mask: PropTypes.string,
  defaultValue: PropTypes.string,
  title: PropTypes.string,
};

export default MaskedTextBoxComponent;
